export default "/assets/images/chart-01.0b9dbafdf3176f81.svg";